import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../services/api";

import "./alerta_grid.scss";

import { styled } from "@mui/material/styles";

import Badge, {
  badgeClasses
} from "@mui/material/Badge";

import IconButton from "@mui/material/IconButton";

import Tooltip from "@mui/material/Tooltip";

import { MdNotificationsActive }
from "react-icons/md";
function Alerta_Grid() {
    const navigate = useNavigate();
    const [totalItems, setTotalItems] = useState(0);
    const [marcadores, setMarcadores] = useState([]);

    async function fetchData() {

        try {

            const { data } = await api.get("/alertas", {
                headers: {
                    typo: localStorage.getItem("id")
                }
            });

            setMarcadores(data.notificacoes_alertas || []);
            setTotalItems(Number(data.total ?? 0));

        } catch (error) {
            console.log("Erro ao buscar alertas:", error);
        }
    }

    useEffect(() => {

        // executa ao abrir
        fetchData();

        // função que atualiza
        const atualizarAlertas = () => {
            fetchData();
        };

        // escuta evento global
        window.addEventListener(
            "atualizar_alertas",
            atualizarAlertas
        );

        // remove listener
        return () => {
            window.removeEventListener(
                "atualizar_alertas",
                atualizarAlertas
            );
        };

    }, []);



    const AlertBadge = styled(Badge)`
  
  & .${badgeClasses.badge} {

    top: 2px;

    right: -3px;

    min-width: 25px;
    height: 25px;

    padding: 0 5px;

    border-radius: 999px;

    background: #0F73B2;

    color: white;

    font-size: 11pt;

    font-weight: 700;

    border: 2px solid #11446d;
  }
`;

  return (

  <Tooltip
    title="Alertas Pendentes"
    arrow
    placement="bottom"
  >

    <IconButton
      onClick={() => navigate("/maps/alertas")}
    >

      <AlertBadge
        badgeContent={totalItems}
        overlap="circular"
         max={9999}
      >

        <MdNotificationsActive
          className="icone-alerta"
        />

      </AlertBadge>

    </IconButton>

  </Tooltip>

);
}

export default Alerta_Grid;